import React, { Component } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { db } from '../config/fbConfig';
import { NavLink, Navigate } from 'react-router-dom';
import './CSS/Dashboard.css';

// Import the sub-pages
import Profile from '../pages/Profile';
import Search from '../pages/Search';
import Membership from '../pages/Membership';

export default class Dashboard extends Component {
  // Local Variables
  constructor(props) {
    super(props);
    this.state = {
      userData: null,
      loading: true,
      error: null,
      uid: null,
      redirectToLogin: false,
      activePage: 'search',
    };
  }

  // Hooks
  componentDidMount() {
    const auth = getAuth();

    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userUid = user.uid;
        this.setState({ uid: userUid });

        try {
          const docRef = doc(db, 'Member_Profiles', userUid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            this.setState({ userData: docSnap.data(), loading: false });
          } else {
            this.setState({ error: 'No such user profile found.', loading: false });
          }
        } catch (err) {
          this.setState({ error: err.message, loading: false });
        }
      } else {
        this.setState({ redirectToLogin: true, loading: false });
      }
    });
  }

  // UI - Design
  render() {
    const { userData, loading, error, redirectToLogin } = this.state;

    const menuItems = [
      { label: 'Search', icon: 'icofont-search-user', page: 'search' },
      { label: 'My Profile', icon: 'icofont-user', page: 'profile' },
      { label: 'Membership', icon: 'icofont-badge', page: 'membership' },
    ];

    if (redirectToLogin) return <Navigate to="/login" />;

    if (loading) {
      return (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading profile...</p>
        </div>
      );
    }

    if (error) {
      return <div className="loading-container" style={{ color: 'red' }}>Error: {error}</div>;
    }

    return (
      <div className="container-fluid mt-4">
        <hr />
        <div className="row">
          {/* Sidebar for Desktop */}
          <div className="col-md-2 mb-4 d-none d-md-block">
            <div className="card sidebar-card">
              <div className="card-body p-4 text-center">
                <img
                  src={`https://varenyamatrimonial.com/profile_images/${userData.User_Id}_1.webp`}
                  className="rounded-circle mx-auto mb-3 sidebar-profile-img"
                  alt="Profile"
                />
                <h5 className="sidebar-heading mb-1">Welcome, {userData.Name}</h5>
                <p className="sidebar-subheading"><strong>({userData.User_Id})</strong></p>
                <ul className="list-group list-group-flush text-start">
                  {menuItems.map((item, index) => (
                    <li
                      key={index}
                      className={`list-group-item sidebar-menu-item d-flex align-items-center ${this.state.activePage === item.page ? 'active' : ''}`}
                      onClick={() => this.setState({ activePage: item.page })}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className={item.icon}></i>
                      <span className="fw-medium ms-2">{item.label}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Main Content Area where routing happens inside Dashboard */}
          <div className="main-content col-md-10">
            {this.state.activePage === 'search' && <Search userData={userData} />}
            {this.state.activePage === 'profile' && <Profile userData={userData} />}
            {this.state.activePage === 'membership' && <Membership userData={userData} />}
          </div>
        </div>

        {/* Bottom Navigation for Mobile */}
        <div className="bottom-nav d-md-none">
          {menuItems.map((item, index) => (
            <div
              key={index}
              className={`text-center ${this.state.activePage === item.page ? 'active' : ''}`}
              onClick={() => this.setState({ activePage: item.page })}
              style={{ flex: 1, cursor: 'pointer' }}
            >
              <i className={item.icon}></i>
              <span>{item.label}</span>
            </div>
          ))}
        </div>

      </div>
    );
  }
}
